import styled from "styled-components";
import { Text } from "@lmn/design-system";
import media from "@/styles/mediaQueries";

export const Container = styled.div`
  margin: 0;
  overflow-wrap: break-word;
  word-break: break-word;
  * {
    overflow-wrap: break-word;
    word-break: break-word;
  }
`;

/* Desktop layout */
export const DesktopFlexRow = styled.div`
  display: none;
  ${media.screenMdMin`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: space-between;
    align-items: flex-end;
  `}
`;

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
`;

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

/* Mobile layout */
export const MobileRows = styled.div`
  display: grid;
  grid-auto-rows: 1fr;
  ${media.screenMdMin`
    display: none;
  `}
`;

export const MobileRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.kallisto.space.space100};
  padding: ${({ theme }) => theme.kallisto.space.space150} 0;
  border-top: 1px solid
    ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  cursor: pointer;
  min-width: 0;
  overflow: hidden;

  & > *:first-child {
    flex: 1;
    min-width: 0;
  }

  & > svg {
    flex-shrink: 0;
    color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  }
`;

export const MobileRowWithBorderBottom = styled(MobileRow)`
  border-bottom: 1px solid
    ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
`;

export const MobileTitleRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.kallisto.space.space100};
  margin-bottom: ${({ theme }) => theme.kallisto.space.space150};
  ${media.screenMdMin`
    display: none;
  `}
`;

export const RatingBadge = styled.span<{ $bgColor: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: ${({ $bgColor }) => $bgColor};
  color: ${({ theme }) => theme.kallisto.color.text.static.textOnDark};
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
  font-size: ${({ theme }) => theme.kallisto.font.size[175]};
  line-height: normal;
`;

export const MobileAddressContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.kallisto.space.space50};
  min-width: 0;
  font-family: ${({ theme }) => theme.kallisto.font.family.sans};
  font-size: ${({ theme }) => theme.kallisto.font.size[175]};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};

  & > svg {
    flex-shrink: 0;
    color: currentColor;
  }
`;

export const MobileAddressText = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const ReviewsRowContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.kallisto.space.space100};
  min-width: 0;
`;
